module.exports = __webpack_public_path__ + "img/blog-9.874362a4.jpg";